module.exports = {
	colors: {
		main: '#003f7e',
		sec: '#009CE1',
		alt: '#003f7e',
	},

	showFunds: false,
	showBuses: false,
	showHomeworks: true,
	useCourses: false,
	useUploadChatImage: false,

	about: {
		mobiles: ['0994205050'],
		phones: [],
		address: 'المحافظة - مفرق مشفى الرازي',
		data: [],
		email: null,
		facebook: null,
		privacy: 'https://alhakem.edunixsystem.com/privacy',
		details: [
			{
				title: 'عن معهدنا',
				content: [
					'معهد الحكيم لدورات شهادات التاسع والبكالوريا ( علمي - أدبي )',
				],
			},
		],
	},

	pwa: {
		name: 'معهد الحكيم',
		shortName: 'معهد الحكيم',
		description: 'معهد الحكيم - نسخة محمولة من تطبيق الموبايل.',
	},
};
